export const ALBUM_GAP = 10;
export const ALBUM_DEFAULT_MAX_WIDTH = 800;
export const ALBUM_SUPPORTED_FILE_FAMILY = ['image', 'video'];

export enum AlbumFamilyType {
    IMAGE = 'image',
    VIDEO = 'video',
    GIF = 'gif',
}
